import { useTextLoading } from './useTextLoading';

interface TextLoadingProps {
  texts?: string[];
}

export const TextLoading = ({ texts = [] }: TextLoadingProps) => {
  const { currentTextIndex, progress, progressRef } = useTextLoading(texts);

  return (
    <div className="flex flex-col items-center justify-center text-center w-full">
      <p className="text-gray-700 text-sm font-normal">
        {texts[currentTextIndex]}
      </p>
      <div className="w-full h-1 bg-gray-300 mt-2 overflow-hidden rounded">
        <div
          ref={progressRef}
          style={{
            width: `${progress}%`,
            transition: 'width 50ms linear',
          }}
          className="h-full bg-blue-500"
        />
      </div>
    </div>
  );
};
